import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../shared";

const AccountActivate = () => {
  const { uid, token } = useParams();
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const accountActivate = async () => {
      try {
        await axios.get(`auth/activate/${uid}/${token}`, {});
        setSuccess(true);
      } catch (err) {
        setSuccess(false);
      }
    };
    accountActivate();
  }, []);

  return (
    <div>
      <div className="d-flex justify-content-center mt-5 text-center">
        {success ? (
          <section>
            <h1>Account Activated</h1>
            <br />
            <p className="fs-5">Your account has been activated.</p>
            <div>
              <a className="btn btn-primary" href="/login">
                Login
              </a>
            </div>
          </section>
        ) : (
          <section>
            <h1 className="text-danger">Account Activation Failed</h1>
            <br />
            <p className="fs-5">
              Contact us through the mail or in the number provided.
            </p>
            <div>
              <a className="btn btn-secondary" href="/contact">
                Contact
              </a>
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default AccountActivate;
